import React, { forwardRef } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Box } from '@fiverr-private/theme';
import { Link } from '@fiverr-private/typography';
import { GoBackToFiverrIcon, GoTimesIcon } from '../../icons';
import { theme } from '../../../theme';
import { appTranslate } from '../../../i18n';
import { IconButton } from '../../buttons';
import { GoSidebarMobileTab } from '../GoSidebarMobileTab';
import { GoLogoIcon } from '../../GoLogoIcon';
import { GoTabProps } from '../GoSidebar.types';

interface GoMobileDrawerProps {
    tabs: GoTabProps[];
    homeUrl: string;
    backToFiverrUrl: string;
    onClose?: () => void;
    style?: React.CSSProperties;
}

export const GoMobileDrawerBody = forwardRef<HTMLElement, GoMobileDrawerProps>(
    ({ tabs, homeUrl, backToFiverrUrl, onClose, style }, ref) => (
        <Stack
            ref={ref}
            as="nav"
            direction="column"
            flexShrink="0"
            padding="4"
            gap="0"
            borderBottomRightRadius="lg"
            borderTopRightRadius="lg"
            borderTopWidth="sm"
            borderBottomWidth="sm"
            borderRightWidth="sm"
            borderStyle="solid"
            marginY="1"
            style={{
                ...style,
                height: 'calc(100% - 8px)',
                width: 280,
                maxWidth: '100vw',
                backgroundColor: theme.colors.grey1200,
                borderColor: theme.colors.grey1100,
            }}
        >
            <Stack alignItems="center">
                <Link href={homeUrl} style={{ display: 'flex' }}>
                    <GoLogoIcon color={theme.colors.grey300} />
                </Link>
                <IconButton variant="tertiary" onClick={onClose} marginLeft="auto">
                    <GoTimesIcon size={18} />
                </IconButton>
            </Stack>
            <Box
                borderTopWidth="sm"
                borderStyle="solid"
                borderRadius="circle"
                marginY="4"
                style={{ borderColor: theme.colors.grey1100 }}
            />
            <Stack as="ul" gap="2" direction="column" marginBottom="auto">
                {tabs.map((tabProps) => (
                    <li key={tabProps.label}>
                        <GoSidebarMobileTab {...tabProps} />
                    </li>
                ))}
            </Stack>
            <Box
                borderTopWidth="sm"
                borderStyle="solid"
                borderRadius="circle"
                marginY="2"
                style={{ borderColor: theme.colors.grey1100 }}
            />
            <GoSidebarMobileTab
                label={appTranslate('go_sidebar.links.back_to_fiverr')}
                Icon={GoBackToFiverrIcon}
                href={backToFiverrUrl}
            />
        </Stack>
    )
);

GoMobileDrawerBody.displayName = 'GoMobileDrawerBody';
